import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Typography, Box, IconButton } from '@mui/material';
import Breadcrumb from 'src/components/Breadcrumb';
import { useDispatch } from 'react-redux';
import { ArrowLeft } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import AddButton from 'src/components/AddButton/AddButton';
import { createLineOfBusinessAction } from 'src/store/actions/catalogActions';
import useStyles from './styles';
import LineOfBusinessForm from './LineOfBusinessForm';

const Toolbar = ({ className, ...rest }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { classes } = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const handleOpenModal = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleCloseModal = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleCreateModel = useCallback(
    values => {
      dispatch(createLineOfBusinessAction(values, handleCloseModal));
    },
    [dispatch, handleCloseModal]
  );

  return (
    <>
      <Box className={clsx(classes.root, className)} {...rest}>
        <Breadcrumb />
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <IconButton onClick={() => navigate(-1)} color="primary" component="span">
              <ArrowLeft />
            </IconButton>
            <Typography
              style={{ fontWeight: '400' }}
              color="primary"
              variant="h1"
            >
              {t('NAVIGATION.CATALOG_LIST.LINES_OF_BUSINESS')}
            </Typography>
          </Box>
          <Box className={classes.actionsContainer}>
            <AddButton
              title={t('CATALOGS_VIEW.LINES_OF_BUSINESS.ADD_LINE_OF_BUSINESS')}
              onClick={handleOpenModal}
            />
            <LineOfBusinessForm
              open={open}
              onClose={handleCloseModal}
              onCreate={handleCreateModel}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  contractStatus: PropTypes.string
};

export default Toolbar;
